import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { device } from "../../styled";
import { Link } from "react-router-dom";
import { barberSHopDatas } from "../../barberShopDatas";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
`;

const MenuOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 100;
  display: ${(props) => (props.show ? "block" : "none")};
`;

const MenuBody = styled.section`
  display: block;
  width: 100%;
  background: #000;
  color: #fff;
  padding-bottom: 15px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -9px 50px -30px black;
  position: absolute;
  bottom: 0;
  z-index: 105;
  display: ${(props) => !props.show && "none"};
  transform: translateY(${(props) => (props.show ? "0" : "150%")});
  transition: 0.2s cubic-bezier(0.33, 1, 0.53, 1);

  a {
    text-decoration: none;
  }

  @media ${device.tablet} {
    width: 40%;
  }
`;

const MenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  font-size: 1rem;
  font-weight: bold;
  background: #fff;
  color: #000;
  border-radius: 50%;
  cursor: pointer;
`;

const ShopName = styled.h1`
  border: 2px #008080 solid;
  border-radius: 10px;
  font-size: 1rem;
  margin: 0;
  padding: 10px 20px;
  cursor: pointer;

  &:hover {
    background-color: #008080;
    border: 2px #fff solid;
  }
`;

const BarberContainer = styled.div`
  overflow-x: scroll;
  display: flex;
  padding: 0 10px;

  @media ${device.tablet} {
  }
`;

const BarberCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 8px;

  a {
    text-decoration: none;
  }
`;

const BarberName = styled.p`
  font-weight: 600;
  width: 70px;
  text-align: center;
  font-size: 0.8em;
  text-align: center;
  margin-bottom: 5px;
`;

const ReserveButton = styled.div`
  text-align: center;
  background-color: #008080;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
  padding: 13px 5px;
  margin: 10px auto 0;

  @media ${device.tablet} {
    width: 200px;
    border: 3px #008080 solid;
    &:hover {
      background-color: #008080;
    }
  }
`;

const HeaderCityName = styled.p`
  font-size: 1.3em;
  font-weight: 800;
`;

const BarberImage = memo(styled.img`
  background-color: #fff;
  width: 60px;
  border: 3px #fff solid;
  border-radius: 50%;
`);

const ShopNameContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 20px;
`;

const InfoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  padding: 0 20px;
  align-items: center;
  gap: 5px;
`;

const SocialIcon = styled.img`
  max-width: 30px;
  max-height: 30px;
  height: auto;
  width: auto;
  display: block;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const BarberCard = memo(({ barber }) => (
  <BarberCardWrapper>
    <BarberImage src={barber.imgPath} />
    <BarberName>{barber.name}</BarberName>
  </BarberCardWrapper>
));

const NavBar = ({ isVisible, setIsNavbarVisible, shopId, setShopId, city }) => {
  useEffect(() => {
    if (shopId) {
      setIsNavbarVisible(true);
    }
  }, [setIsNavbarVisible, shopId]);

  const handleClose = () => {
    setShopId(false);
    setIsNavbarVisible(false);
  };

  return (
    <Wrapper>
      <MenuOverlay show={isVisible} onClick={() => setIsNavbarVisible(false)} />
      <MenuBody show={isVisible}>
        <MenuHeader>
          <HeaderCityName>{city || "ARTIST EST. 2023"}</HeaderCityName>
          <CloseButton onClick={handleClose}>X</CloseButton>
        </MenuHeader>
        {!shopId ? (
          <ShopNameContainer>
            <ShopName onClick={() => setShopId("gyor")}>GYŐR</ShopName>
            <ShopName onClick={() => setShopId("moson")}>
              MOSONMAGYARÓVÁR
            </ShopName>
            <ShopName onClick={() => setShopId("csorna")}>CSORNA</ShopName>
            <ShopName onClick={() => setShopId("fertod")}>FERTŐD</ShopName>
          </ShopNameContainer>
        ) : (
          <>
            <InfoWrapper>
              <InfoContainer>
                <SocialIcon src="/gps.png" />
                <p>{barberSHopDatas[shopId].location}</p>
              </InfoContainer>
              <InfoContainer>
                <SocialIcon src="/tel.png" />
                <p>{barberSHopDatas[shopId].phone}</p>
              </InfoContainer>
            </InfoWrapper>
            <BarberContainer>
              {barberSHopDatas[shopId].barbers.map((barber) => {
                return <BarberCard key={barber.name} barber={barber} />;
              })}
            </BarberContainer>
          </>
        )}
        {shopId && (
          <Link to={barberSHopDatas[shopId].link}>
            <ReserveButton>Foglalj a szalonba</ReserveButton>
          </Link>
        )}
      </MenuBody>
    </Wrapper>
  );
};
export default NavBar;
